import React from 'react'

export const trackPage = (name) => {
    React.useEffect(() => {
        location.hash = name
    }, [])
}

export const track = (name, property) => {
    try {
        global.heap.track(name, property)
    } catch(e) {
    }
}



// WEBPACK FOOTER //
// ./src/twd/track.js